import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Choice from '@components/choice/Choice'
import Animators from '@components/root/Animators'

import useI18n from '@i18n/useI18n'

import * as IncidentSore from '@store/incident/incident'

import { FormikHelpers, useFormik } from 'formik'

interface Values {
  isInfrastructure: 'PRESTA' | 'INFRA'
}

const valuesToReset: (keyof IncidentForm)[] = [
  'space',
  'location',
  'subLocation',
  'subsubLocation',
  'plan',

  'familles',
  'famillesDeepLength',
  'famillesMinEditable',

  'enseigneCommande',
  'isCommandeOrganisateur',
  'numeroCommande',
  'referenceArticleCommande',
  'alleeCommande',
  'standCommande',
  'espaceCommande',
  'enseigneMail',
  'enseignes',
  'completed',
]

const Type = ({ form, onForm, spaceId }: IncidentFormProps) => {
  const init: Values = React.useMemo(() => ({ isInfrastructure: form.isInfrastructure }), [form.isInfrastructure])

  const i18n = useI18n()

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    const resetValues =
      vals.isInfrastructure !== form.isInfrastructure
        ? valuesToReset.reduce(
            (acc, cur) => ({ ...acc, [cur]: IncidentSore.initialState.form[cur] }),
            {} as Partial<IncidentForm>
          )
        : {}

    onForm({ ...resetValues, ...vals, enseignes: [], commandSearch: 'location' }, true).finally(() =>
      setSubmitting(false)
    )
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  const options = [
    { label: i18n.t('screens.incident.TYPE.presta'), value: 'PRESTA', disabled: !form.manifestationId || !!spaceId },
    { label: i18n.t('screens.incident.TYPE.infra'), value: 'INFRA' },
  ]

  const opt = options.find((o) => values.isInfrastructure === o.value)

  return (
    <MainContainer>
      <Animators>
        <Choice data={options} onItemSelected={(next) => setFieldValue('isInfrastructure', next.value)} value={opt} />
      </Animators>
    </MainContainer>
  )
}

export default Type

const MainContainer = styled(View)`
  margin: 0 20px;
  padding-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 175)}px;
`
